export const DEFAULT_FIRM_TITLE_OPTIONS = [
  "Executive",
  "Partners",
  "Associates",
  "Of Counsel",
];

export function normalizeListingCategories(
  values: unknown,
): string[] | undefined {
  if (!Array.isArray(values) || values.length === 0) {
    return undefined;
  }
  const cleaned = values
    .map((value) => String(value ?? "").trim())
    .filter(Boolean);
  return cleaned.length ? cleaned : undefined;
}

export function resolveFirmTitleOptions(
  listingCategory: unknown,
): string[] {
  return normalizeListingCategories(listingCategory) ?? DEFAULT_FIRM_TITLE_OPTIONS;
}
